'use strict';

var React = require('react'),
    Img = require('../atoms/Image'),
    ImageCaption = require('./ImageCaption'),
    StampImageMixin = require('../mixins/StampImageMixin'),
    PureRenderMixin = require('../mixins/PureRenderMixin');

require('./GalleryImage.less');

var GalleryImage = React.createClass({
  mixins: [PureRenderMixin, StampImageMixin],

  propTypes: {
    stamp: React.PropTypes.object.isRequired,
    className: React.PropTypes.string.isRequired,
    style: React.PropTypes.object,
    caption: React.PropTypes.string,
    image: React.PropTypes.object.isRequired,
    imageStyle: React.PropTypes.object,
    imageSizes: React.PropTypes.object,
    onTransitionEnd: React.PropTypes.func.isRequired,
    onClick: React.PropTypes.func.isRequired
  },

  getImage(props) {
    return props.image;
  },

  getImageSizes() {
    return this.props.imageSizes;
  },

  render() {
    return (
      <div className={this.props.className}
           data-scroll-anchor
           onClick={this.toggleAttributionOnMobile}
           style={this.props.style}>

        <div className='stamp-GalleryImage'>
          <div className='stamp-GalleryImage-imageWrapper'>
            <Img src={this.getImageSrcUrl()}
                 style={this.props.imageStyle}
                 onClick={this.handleImageClick}
                 onTransitionEnd={this.props.onTransitionEnd}
                 onLoad={this.handleImageLoad}
                 onError={this.handleImageError} />
            {this.renderUsageCounter()}
            {this.renderAttributionOnMobile()}
          </div>

          {this.props.caption.length > 0 &&
            <ImageCaption caption={this.props.caption} />
          }
        </div>
      </div>
    );
  },

  handleImageClick(e) {
    this.props.onClick(this.props.image, e);
  }
});

module.exports = GalleryImage;



/** WEBPACK FOOTER **
 ** ./stamp/GalleryImage.jsx
 **/